import CheatModeShow from './cheat-mode.show';
import CheatModeList from './cheat-mode.list';
import CheatModeCreate from './cheat-mode.create';

export default {
  show: CheatModeShow,
  list: CheatModeList,
  create: CheatModeCreate,
};
